/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Upload_FileInputs */



/**
* | output |
* | --- |
* | "Import" |
*
* @param {Archon_Upload_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_upload_file = /** @type {((inputs?: Archon_Upload_FileInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Upload_FileInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa")
	return /** @type {LocalizedString} */ ("Import")
});